/**
 * Properties reducer.
 * @module reducers/toolbar/toolbar
 */

import { GET_AUTHOR } from '../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: {},
};

export default function authors(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_AUTHOR}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: {},
      };
    case `${GET_AUTHOR}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result,
      };
    case `${GET_AUTHOR}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: {},
      };
    default:
      return state;
  }
}
